import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalDistributionStaff(props) {
  const employeeStatus = props.model;

  return (
    <Modal
      title="Estado empleado"
      model={employeeStatus}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/employee-status"
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={!!employeeStatus ? employeeStatus.code : ""}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={!!employeeStatus ? employeeStatus.description : ""}
        required
      />
    </Modal>
  );
}
